import React from 'react'

import { Button } from 'src/chrome'
import {
  BottomNav,
  CATALOG_ITEM,
  RELATIONSHIPS_ITEM,
} from 'src/chrome/BottomNav/BottomNav'
import { OrderWithPartialLines } from 'src/redux/reducers/orders'

import styles from './orderFooter.module.scss'

interface Props {
  isSaving: boolean
  isInvalid: boolean
  order: OrderWithPartialLines
  cancel: () => void
  saveAs: () => void
  onSendOrder: () => void
  addRecipients: () => void
  toggleAddressBlinker: (toggle: boolean) => void
}

const OrderFooter: React.FC<Props> = props => {
  const {
    isSaving,
    isInvalid,
    order,
    cancel,
    saveAs,
    onSendOrder,
    addRecipients,
    toggleAddressBlinker,
  } = props

  return (
    <footer className={styles.orderFooter} style={{ zIndex: 115 }}>
      <div className={styles.desktop}>
        {!order.isSent && (
          <Button
            id={'cancel_order_btn'}
            onClick={cancel}
            title="Cancel Order"
            style={{ marginLeft: 10 }}
          />
        )}
        <div className={`${styles.orderInfo} ${styles.cta}`}>
          {!isInvalid && (
            <Button
              id={'save_as_campaign_btn'}
              title="Save As Campaign"
              onClick={saveAs}
              style={{ marginRight: '25px' }}
              disabled={isSaving}
              buttonColor="blue"
            />
          )}
          {isInvalid ? (
            order?.returnAddress ? (
              <Button
                id={'add_recipients_btn'}
                title={'Add Recipients'}
                className={styles.cta}
                onClick={addRecipients}
                buttonColor={'pink'}
              />
            ) : (
              <Button
                title={'Add Return Address'}
                className={styles.cta}
                buttonColor={'pink'}
                onClick={() => {
                  const element = document.querySelector('#first_name_field')
                  if (element != null && element instanceof HTMLElement) {
                    element.focus()
                  }
                  toggleAddressBlinker(true)
                }}
              />
            )
          ) : (
            <Button
              id={'ready_to_send_btn'}
              title={
                isSaving
                  ? 'Saving...'
                  : order.isSent
                  ? 'This order has been sent!'
                  : 'Ready to Send'
              }
              className={styles.cta}
              onClick={onSendOrder}
              disabled={isSaving || order.isSent || !order.isSendable}
              buttonColor={'pink'}
            />
          )}
        </div>
      </div>
      <div className={styles.mobile}>
        <BottomNav
          items={[
            CATALOG_ITEM,
            RELATIONSHIPS_ITEM,
            {
              id: 'delete_order_btn',
              icon: 'TRASH',
              label: 'Cancel',
              onClick: cancel,
            },
          ]}
        />
      </div>
    </footer>
  )
}

export default OrderFooter
